export const APP_AUTHENTICATE = 'APP_AUTHENTICATE';
export const APP_MSAL_SETUP = 'APP_MSAL_SETUP';
export const APP_AVATAR = 'APP_AVATAR';